module.exports = __webpack_public_path__ + "img/remove_icon_3.9fd52cb9.webp";